import { NativeDateAdapter, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { Inject, Injectable } from '@angular/core';

// 1. Define tus formatos de fecha personalizados
// 'parse' indica cómo el datepicker debe intentar convertir una cadena a un objeto Date.
// 'display' indica cómo el datepicker debe formatear un objeto Date a una cadena para mostrar.
export const MY_DATE_FORMATS = {
  parse: {
    // Aquí especificamos los formatos que aceptaremos para la entrada manual.
    // El orden puede importar si hay ambigüedad, pero para dd/MM/YYYY y dd-MM-YYYY no suele haber.
    dateInput: ['DD/MM/YYYY', 'DD-MM-YYYY'],
  },
  display: {
    // Este es el formato en el que se mostrará la fecha en el input una vez seleccionada o parseada.
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY', // Formato para la etiqueta del mes y año en el calendario
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// 2. Crea tu adaptador de fecha personalizado
// Este adaptador extiende NativeDateAdapter y sobrescribe el método 'parse'
// para manejar tus formatos de entrada específicos.
@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  // El constructor es importante para que el adaptador pueda inyectar el locale.
  constructor(@Inject(MAT_DATE_LOCALE) matDateLocale: string) {
    super(matDateLocale);
  }

  // Sobrescribe el método 'parse' para convertir la cadena de entrada a un objeto Date.
  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.length > 0) {
      // Intenta dividir la cadena por '/' o '-'
      const dateParts = value.split(/[\/\-]/);

      if (dateParts.length === 3) {
        const day = parseInt(dateParts[0], 10);
        const month = parseInt(dateParts[1], 10);
        const year = parseInt(dateParts[2], 10);

        // Realiza una validación básica para asegurar que son números válidos y rangos razonables.
        // Puedes añadir validaciones más robustas si lo necesitas.
        if (!isNaN(day) && !isNaN(month) && !isNaN(year) &&
            day >= 1 && day <= 31 &&
            month >= 1 && month <= 12 &&
            year >= 1900 && year <= 2100) // Ajusta el rango de años según tus necesidades
        {
          // Crea un objeto Date. ¡Importante! El mes en JavaScript es 0-indexado (0 para enero, 11 para diciembre).
          const date = new Date(year, month - 1, day);

          // Verifica si la fecha creada es realmente válida (ej. evita 31/02/2023)
          // Comprueba que el año, mes y día del objeto Date coinciden con los valores originales.
          if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) {
            return date;
          }
        }
      }
    }
    // Si la cadena no coincide con tus formatos o es nula/vacía,
    // llama al método 'parse' del adaptador nativo como fallback o devuelve null.
    return super.parse(value);
  }

  // Opcional: Si necesitas un formato de visualización muy específico que no se cubre con MY_DATE_FORMATS.display.dateInput
  // puedes sobrescribir el método 'format' aquí. Sin embargo, para DD/MM/YYYY, MY_DATE_FORMATS ya es suficiente.
  // format(date: Date, displayFormat: Object): string {
  //   if (displayFormat === 'DD/MM/YYYY') {
  //     const day = date.getDate().toString().padStart(2, '0');
  //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //     const year = date.getFullYear();
  //     return `${day}/${month}/${year}`;
  //   }
  //   return super.format(date, displayFormat);
  // }
}